export const PROFILE_ROLE = {
    subscriberAdministrator: 'Subscriber_Administrator',
    companyAdministrator: 'Company_Administrator',
    buAccessAdministrator:'BU_Access_Administrator',
    buSubscriberViewer: 'BU_Subscriber_Viewer',
    administrator: 'Administrator'
}
